import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "text-gray-800" }
const _hoisted_2 = { class: "text-gray-500" }

import { ref } from "vue";
import { IAlertMessage } from "@/interfaces/PointInterfaces";

export default /*@__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
  isDismissable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {

let isActive = ref(false);
let alertType = ref("danger");
let alertTitle = ref("");
let alertMessage = ref("");
//Props
const props = __props;
const displayAlert = (alert_type: string, message: IAlertMessage) => {
  alertType.value = alert_type;
  alertTitle.value = message.title;
  alertMessage.value = message.text;
  setAlertVisibility(true);
};
const setAlertVisibility = (is_visible: boolean) => {
  isActive.value = is_visible;
  if (!props.isDismissable) {
    setTimeout(() => {
      isActive.value = false;
    }, 5000);
  }
};
__expose({ displayAlert });

return (_ctx: any,_cache: any) => {
  const _component_snap_alert_title = _resolveComponent("snap-alert-title")!
  const _component_snap_alert_description = _resolveComponent("snap-alert-description")!
  const _component_snap_link = _resolveComponent("snap-link")!
  const _component_snap_alert_action = _resolveComponent("snap-alert-action")!
  const _component_snap_alert = _resolveComponent("snap-alert")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-up" }, {
    default: _withCtx(() => [
      (_unref(isActive))
        ? (_openBlock(), _createBlock(_component_snap_alert, {
            key: 0,
            type: _unref(alertType),
            border: true,
            class: "flex justify-center fixed w-full top-[150px] lg:left-[5%] lg:right-[5%] z-[999999]"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_snap_alert_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(alertTitle)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_snap_alert_description, { class: "xs:w-fit sm:w-72 md:w-fit md:max-w-md" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(alertMessage)), 1)
                ]),
                _: 1
              }),
              (__props.isDismissable)
                ? (_openBlock(), _createBlock(_component_snap_alert_action, {
                    key: 0,
                    slot: "start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_snap_link, {
                        text: "Dismiss",
                        "sr-only": "srOnly",
                        target: "_self",
                        size: "sm",
                        variant: _unref(alertType),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (setAlertVisibility(false)))
                      }, null, 8, ["variant"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["type"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})